import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "../../../App";

// Sugere o diário e o nº de serviço do próximo voo da aeronave (decisão de 09/10: sequência por aeronave,
// diário mudado à mão, números numéricos). Só preenche os campos que a pessoa ainda não mexeu.
export function useAircraftNumberSuggestion({ aircraftRegistration, isEdit, setForm }) {
  const touched = useRef({ nav: false, svc: false });
  const [suggestion, setSuggestion] = useState(null);

  useEffect(() => {
    if (isEdit) return undefined;
    const reg = (aircraftRegistration || "").trim();
    if (!reg) {
      setSuggestion(null);
      return undefined;
    }
    let cancelled = false;
    axios
      .get(`${API}/di/aircraft-next-numbers`, { params: { aircraft_registration: reg }, withCredentials: true })
      .then((r) => {
        if (cancelled) return;
        setSuggestion(r.data);
        setForm((f) => ({
          ...f,
          navigation_log_number: touched.current.nav ? f.navigation_log_number : (r.data.navigation_log_number || ""),
          service_number: touched.current.svc ? f.service_number : (r.data.service_number || ""),
        }));
      })
      .catch(() => {
        if (!cancelled) setSuggestion(null);
      });
    return () => {
      cancelled = true;
    };
  }, [aircraftRegistration, isEdit, setForm]);

  const markTouched = (field) => {
    touched.current[field] = true;
  };

  const hasSuggestion = Boolean(suggestion && (suggestion.navigation_log_number || suggestion.service_number));
  return { hasSuggestion, markTouched };
}
